import React, { lazy, Suspense } from 'react';

import { type RouteComponentProps } from 'react-router-dom';

type TeamEmbedProps = { teamId: string };

const TeamEmbedSuspense = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlaskit-internal_async-standalone-directory_team-embed-page" */ './main'
		),
);

const LazyTeamEmbed = (props: TeamEmbedProps): React.ReactElement => (
	<Suspense fallback={null}>
		<TeamEmbedSuspense {...props} />
	</Suspense>
);

const TeamEmbedRoute = ({
	match,
}: Pick<RouteComponentProps<{ teamId: string }>, 'match'>): React.JSX.Element => {
	return <LazyTeamEmbed teamId={match.params.teamId} />;
};

export default TeamEmbedRoute;
